import {
  AppIdentity,
  GetCurrentUserAiPointsUsageQuery,
  GetCurrentUserAiPointsUsageQueryVariables,
  GetCurrentUserQuery,
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables,
  type DestroyCurrentUserMutation,
  type DestroyCurrentUserMutationVariables,
  type GetCurrentUsageAndBalanceQuery,
  type GetTodayStatsQuery,
} from '@/typings/domain'
import apolloClient from './apolloClient'
import DestroyCurrentUserGQL from './graphql/DestroyCurrentUser.graphql'
import GetCurrentUsageAndBalanceGQL from './graphql/GetCurrentUsageAndBalance.graphql'
import GetCurrentUserGQL from './graphql/GetCurrentUser.graphql'
import GetCurrentUserAIPointsUsageGQL from './graphql/GetCurrentUserAIPointsUsage.graphql'
import GetTodayStatsGQL from './graphql/GetTodayStats.graphql'
import UpdateUserProfileGQL from './graphql/UpdateUserProfile.graphql'

export function getCurrentUser() {
  return apolloClient.query<GetCurrentUserQuery>({
    query: GetCurrentUserGQL,
    variables: {
      appIdentity: AppIdentity.Nextapp,
    },
  })
}

export function updateUserProfile(input: UpdateUserProfileMutationVariables['input']) {
  return apolloClient.mutate<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>({
    mutation: UpdateUserProfileGQL,
    variables: {
      input,
    },
  })
}

export function getCurrentUsageAndBalance() {
  return apolloClient.query<GetCurrentUsageAndBalanceQuery>({
    query: GetCurrentUsageAndBalanceGQL,
  })
}

export function getTodayStats() {
  return apolloClient.query<GetTodayStatsQuery>({
    query: GetTodayStatsGQL,
  })
}

export function destroyCurrentUser(input: DestroyCurrentUserMutationVariables['input']) {
  return apolloClient.mutate<DestroyCurrentUserMutation, DestroyCurrentUserMutationVariables>({
    mutation: DestroyCurrentUserGQL,
    variables: { input },
  })
}

export function getCurrentUserAIPointsUsage() {
  return apolloClient.query<GetCurrentUserAiPointsUsageQuery, GetCurrentUserAiPointsUsageQueryVariables>({
    query: GetCurrentUserAIPointsUsageGQL,
    fetchPolicy: 'no-cache',
  })
}
